module.exports = __webpack_public_path__ + "static/media/nufactor-logo.6735701c.png";